import styled from "styled-components";

export const Title = styled.div`
  margin: 2rem 0;
  font-size: 2rem;
  font-weight: 600;
  color: #0a85c7;
  display: flex;
  justify-content: center;
  line-height: 2rem;
`;
export const CTAContainer = styled.div`
  display: flex;
  column-gap: 0.5rem;
  justify-content: center;
  margin-bottom: 3rem;
`;
export const BlackHighlight = styled.span`
  color: #06496d;
  padding: 0 10px;
  font-weight: 700;
`;

export const StepContainer = styled.div<{
  height?: string;
  withPadding?: boolean;
}>`
  border: 1px solid #cbd9e1;
  border-radius: 4px;
  padding: ${(props) => (props.withPadding ? "1rem 2rem" : "0px")};
  margin-bottom: 3rem;
  height: ${(props) => props.height ?? "unset"};
  overflow-y: clip;
`;
export const BoxTitle = styled.div<{ withPadding?: boolean }>`
  font-size: 1.5rem;
  font-weight: 500;
  color: #355263;
  padding: ${(props) => (props.withPadding ? "1rem 0 0 2rem" : "0px")};
`;
export const BannerContentContainer = styled.div`
  display: flex;
  color: #651717;
  flex-direction: column;
`;
export const BannerTitle = styled.div`
  font-size: 1.25rem;
`;
export const BannerContent = styled.div`
  font-size: 1rem;
`;
export const BannerHighlight = styled.span<{ withUnderline?: boolean }>`
  color: #651717;
  font-weight: 700;
  font-size: 18px;
  text-decoration: ${(props) => (props.withUnderline ? "underline" : "unset")};
`;
